import { Box, Chip, MenuItem, Select } from "@mui/material";
import React from "react";
import PropTypes from 'prop-types';
const SelectInputs1 = ({
  modules,
  cruiseType,
  style,
  options,
  agencyType,
  selectedValue,
  setSelectedValue,
  disabled,
  onChange
}) => {
  const handleDelete = (value) => {
    setSelectedValue(selectedValue.filter((item) => item !== value));
  };
  const key =
    cruiseType === "agencyCode"
      ? "agencyCode"
      : cruiseType === "seawareAgencyCode"
      ? "seawareAgencyCode"
      : null;

  return (
    <Select
      required={agencyType==="DisplayAgency"}
      style={{ ...style }}
      multiple
      disabled={disabled}
      renderValue={(selected) => (
        <Box
          sx={{ display: "flex", gap: 0.5, overflow: "scroll" }}
          className="noScrollBar"
        >
          {selected.map((value, index) => (
            <Chip
              key={value}
              onMouseDown={(event) => {
                event.stopPropagation();
              }}
              color="error"
              onDelete={() => !disabled && handleDelete(value)}
              sx={{
                borderRadius: "4px",
                "& .MuiChip-label": {
                  color: "white",
                  fontWeight: "bold",
                },
              }}
              label={value}
            ></Chip>
          ))}
        </Box>
      )}
      value={selectedValue}
      onChange={(e) => {
        setSelectedValue(e.target.value); 
        if (onChange) onChange(e.target.value);
      }}
    >
      {options?.map((item, index) => (
        <MenuItem key={index} value={item[key]}>
          {item[key]} 
        </MenuItem>
      ))}
    </Select>
  );
};
SelectInputs1.propTypes = {
  modules: PropTypes.any,
  cruiseType:PropTypes.any,
  style: PropTypes.any,
  options: PropTypes.any,
  agencyTypeType: PropTypes.any,
  selectedValue: PropTypes.any,
  setSelectedValue: PropTypes.any,
  disabled: PropTypes.any,
};
export default SelectInputs1;
